import { Assessment } from './assessment';

export interface AssessmentCategory {
    name: string;
    class: string;
    assessments: Assessment[];
}
